





import {Component, Prop, Watch} from "vue-property-decorator"
import Vue from "vue"
import {ActiveProvide} from "@/support/reactive"


@Component({})
export default class Provider1 extends Vue {
    @ActiveProvide('jds.test.provide1') var1 = '';
    @Prop() toInject!: string;

    @Watch('toInject', {immediate: true})
    syncProvide() {
        this.var1 = this.toInject;
    }
}
